module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_structure-29c9cd1f1b2606fa5bcaae6a7d0afa6b.svg";